import React, { useReducer } from 'react';

export const AuthContext = React.createContext();

const initialStatus = {
  user: null,
  person: null,
  role: null,
};

const AuthReducer = (state, action) => {
  switch (action.type) {
    case 'set_user':
      return {
        ...state,
        user: action.user,
        person: action.person,
      };

    case 'set_person':
      return {
        ...state,
        person: action.person,
        role: action.role,
      };

    default:
      return state;
  }
};

export const AuthProvider = (props) => {
  const [state, dispatch] = useReducer(AuthReducer, initialStatus);

  return (
    <AuthContext.Provider value={[state, dispatch]}>
      {props.children}
    </AuthContext.Provider>
  );
};
